module.exports = __webpack_public_path__ + "img/mapa.53eefae3.svg";